import { Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
// import _ from 'lodash';
import { useParams } from 'react-router-dom';
// import StoryContext from '../../contexts/StoryContext';
import FiltersContext from '../../contexts/FiltersContext';
import { composeWhereClause } from '../../modules/data';
import { rdsTabulate } from '../../modules/rds';
// import states, { stateFIPS } from '../../modules/states';
import { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import NoDataVisual from '../NoDataVisual';
import { years } from '../../modules/years';

function ProvidersChangeQualityRating() {
  const { stateCode } = useParams();
  const { displayBy } = useContext(FiltersContext);
  const [, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState({});
  const [noData, setNoData] = useState(false);

  useEffect(() => {
    setError(null);
    setReady(false);
    setNoData(false);
    const getCapacity = function getCapacity() {
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND qris_participation=1`;
      whereClause += composeWhereClause({}, true, false); // don't use child age

      let measure = 'capacity:SUM(capacity_tot)';
      if (displayBy === 'Providers') {
        measure = 'capacity:SUM(cnt_provider)';
      }

      return rdsTabulate('ccdc', 'tract_licensed_capacity', {
        dims: 'wave_id,qris_code',
        measure,
        where: whereClause,
        format: 'amcharts',
        orderby: 'qris_code',
      }, false, null); // use cache, unset wave
    };

    getCapacity().then((response) => {
      // console.log(response.parsedBody.dataProvider);
      const dataItems = response.parsedBody.dataProvider;
      if (dataItems.length === 0) {
        setNoData(true);
        return;
      }

      const waveObjects = {};
      let highestRating = '';
      dataItems.forEach((di) => {
        highestRating = di.qris_code; // data is sorted by qris code. the last one is the highest.
        let dataObject = { ...di };
        const label = di.wave_id === years.rdsCovidWave.toString() ? 'from' : 'to';
        const v = {};
        v[label] = di.capacity;
        dataObject = { ...dataObject, ...v };
        const originalDataObject = waveObjects[di.qris_code] || {};
        waveObjects[di.qris_code] = { ...originalDataObject, ...dataObject };
      });
      setData(waveObjects[highestRating]); // only grab the highest rating data
    })
      .catch((e) => {
        setError(e);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode, displayBy]);

  function getDifference() {
    if (data.from === data.to) {
      return <span>not changed</span>;
    }
    return <span>changed from <b>{toFormattedNumber(data.from)}</b> to <b>{toFormattedNumber(data.to) || 0}</b></span>;
  }

  if (noData) {
    return <NoDataVisual message="No state-wide QRIS system" />;
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      Since the beginning of the COVID-19 pandemic, the number of licensed <b>{displayBy.toLowerCase()}</b> at the highest&nbsp;
      quality level has {getDifference()}.
      See the chart below to compare the change in child care providers by quality level.
    </>
  );
}

export default ProvidersChangeQualityRating;
